window.addEventListener("DOMContentLoaded", () => {
    const showMoreReviewsButton = document.querySelector(".show-more-reviews");
    let btnTxt = null;
    let caret = null;

    if(showMoreReviewsButton) {
        btnTxt = showMoreReviewsButton.querySelector('.show-more-reviews-txt');
        caret = showMoreReviewsButton.querySelector('svg');
    }

    const reviewContainer = document.querySelector("#reviews");
    const reviews = document.querySelectorAll('#reviews .review');
    let allReviewsShown = false;

    if (showMoreReviewsButton !== null && reviewContainer !== null && btnTxt !== null) {
        reviews.forEach((review, index) => {
            review.style.display = index < 4 ? "block" : "none";
        });

        showMoreReviewsButton.addEventListener("click", () => {
            if (!allReviewsShown) {
                let counter = 0;

                reviews.forEach((review) => {
                    if (review.style.display === "none" && counter < 10) {
                        review.style.display = "block";
                        counter++;
                    }
                });

                allReviewsShown = Array.from(reviews).every(review => review.style.display === "block");

                btnTxt.textContent = allReviewsShown ? btnTxt.dataset.close : btnTxt.dataset.open;

                if(allReviewsShown) {
                    caret.classList.toggle('rotate');
                }
            } else {
                reviews.forEach((review, index) => {
                    if (index >= 4) {
                        review.style.display = "none";
                    }
                });

                btnTxt.textContent = btnTxt.dataset.open;
                allReviewsShown = false;

                if(!allReviewsShown) {
                    caret.classList.toggle('rotate');
                }
            }
        });
    }
});